<template>
  <div
    class="st-dropdown-button"
    :class="[{ 'border-important-focusedBorder': isFocused }, { disabled: isDisabled }]"
    @click="clickHandler"
  >
    <div class="st-dropdown-button-label-wrap">
      <ProjectIcon
        v-if="iconName"
        :project-icon="iconName"
        :project-color="iconColor"
        :type="iconType"
      />
      <span
        v-if="label"
        class="st-dropdown-button-label"
        >{{ label }}</span
      >
      <span
        v-if="rightSideLabel"
        class="flex-shrink-0 text-sm text-text-default"
      >
        {{ rightSideLabel }}
      </span>
    </div>
    <em
      v-if="showChevron"
      :style="getCustomIconStyle(iconPath('chevron-up'))"
      :class="
        isFocused
          ? 'custom-icons dropdown-wrap-arrow-down'
          : 'custom-icons dropdown-wrap-arrow-down rotate-180'
      "
    />
  </div>
</template>

<script>
import customIconMixin from '@/mixins/customIconsMixin';
import ProjectIcon from '@/components/elements/common/ProjectIcon.vue';

export default {
  name: 'StDropdownButton',
  components: { ProjectIcon },
  mixins: [customIconMixin],
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    rightSideLabel: {
      type: String,
      required: false,
      default: '',
    },
    isFocused: {
      type: Boolean,
      required: false,
      default: false,
    },
    showChevron: {
      type: Boolean,
      required: false,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconName: {
      type: String,
      required: false,
      default: '',
    },
    iconColor: {
      type: String,
      required: false,
      default: '',
    },
    iconType: {
      type: String,
      required: false,
      default: 'icon',
    },
  },
  emits: ['click'],
  methods: {
    clickHandler() {
      if (this.isDisabled) return;
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
.st-dropdown-button {
  @apply flex
    flex-row
    justify-between
    items-center
    border
    border-solid
    border-standard-border
    rounded
    px-[11px]
    py-[7px]
    cursor-pointer
    bg-standard-bg
    gap-x-2;

  &.disabled {
    @apply cursor-not-allowed border-standard-deleteButtonBorder bg-inactive-bg;
  }

  .st-dropdown-button-label-wrap {
    @apply flex gap-x-2 items-center overflow-hidden;

    .st-dropdown-button-label {
      @apply text-text-default text-sm truncate;
    }
  }
}
</style>
